import {useUser} from '@lore/auth';
import {PayloadStates} from '@lore/utils';
import useUserTags from './useUserTags';
import TagTypes from '../constants/TagTypes';
import useTags from './useTags';
import _ from 'lodash';

export default function useIntents(user) {
  const currentUser = useUser();
  const theUser = user || currentUser;

  const intents = useTags(TagTypes.Intent);
  const userIntents = useUserTags(theUser, TagTypes.Intent);

  if (
    intents.state === PayloadStates.FETCHING ||
    userIntents.state === PayloadStates.FETCHING
  ) {
    return { fetching: true};
  }

  const educatorIntent = _.find(intents.data, intent => intent.data.name === 'Educator');
  const hasEducatorIntent = _.find(userIntents.data, intent => intent.data.id === educatorIntent.id);

  const partnerIntent = _.find(intents.data, intent => intent.data.name === 'Partner');
  const hasPartnerIntent = _.find(userIntents.data, intent => intent.data.id === partnerIntent.id);

  let isEducator = !!hasEducatorIntent;
  let isPartner = !!hasPartnerIntent;
  if (!hasPartnerIntent && !hasEducatorIntent) {
    // fallback to user record if no intents are found
    isEducator = theUser && theUser.data && theUser.data.isEducator
    isPartner = !isEducator;
  }

  return {
    isEducator,
    isPartner,
    isOnlyPartner: !isEducator && isPartner,
    isOnlyEducator: isEducator && !isPartner,
    fetching: false
  };
};
